import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText,
} from '@facet-wealth/design';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('message', {
    _component: () => Richtext,
    _customProps: { Component: FDBodyText },
  }, overrideReadOnly);

export default metaOverrideSet;
